module.exports = __webpack_public_path__ + "img/retrospect-129-mobile.6a9173cd.jpg";